import React from "react";

// eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
export const StopPropagationComponent: React.FC<{ children: React.ReactNode }> = ({ children }) => <div onClick={(e) => e.stopPropagation()}>{children}</div>;
